import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'reactstrap';
import ApiError from 'components/common/ApiError';
import IconInput from 'components/iconInput/IconInput';
import CardWithLoader from 'components/common/CardWithLoader';
import APIResultMessage from 'components/common/APIResultMessage';
import { UserSettingsContext } from 'contexts/UserSettingsContext';
import { useAccountSettingsOptions } from 'hooks/useAccountSettingsOptions';

const TYPE_MAP = {
    analyze_all_contacts: "checkbox",
    auto_send_after_talking: "checkbox",
    default_account_settings: "elementSelect",
    is_ai_control_visible: "checkbox",
    is_assistant_talking: "checkbox",
    is_avatars_visible: "checkbox",
    is_chat_sessions_visible: "checkbox",
    is_chats_visible: "checkbox",
    is_chat_designs_visible: "checkbox",
    is_companies_visible: "checkbox",
    is_communication_plans_visible: "checkbox",
    is_contracts_visible: "checkbox",
    is_customers_visible: "checkbox",
    is_documents_visible: "checkbox",
    is_account_settings_visible: "checkbox",
    is_emails_visible: "checkbox",
    is_events_visible: "checkbox",
    is_event_participants_visible: "checkbox",
    is_schedulers_visible: "checkbox",       
    is_import_data_visible: "checkbox",               
    is_integrations_visible: "checkbox",
    is_interactions_visible: "checkbox",
    is_knowledge_visible: "checkbox",
    is_list_page_length: "range",
    is_message_templates_visible: "checkbox",
    is_metadata_visible: "checkbox",                  
    is_notes_visible: "checkbox",
    is_orders_visible: "checkbox",
    is_products_visible: "checkbox",
    is_profile_visible: "checkbox",
    is_prompts_visible: "checkbox",                   
    is_roles_visible: "checkbox",
    is_settings_visible: "checkbox",
    is_signatures_visible: "checkbox",
    is_term_corrections_visible: "checkbox",           
    is_todos_visible: "checkbox",
    is_uploads_visible: "checkbox",
    is_users_visible: "checkbox",
    show_icons: "checkbox",
    analyze_all_contacts: "text"
};


const UserSettings = () => {
    const { t } = useTranslation();
    const { data, userSettings, isLoading, error, saveLineKey, refetch, success, saveError } = useContext(UserSettingsContext);
    const { accountSettingsOptions} = useAccountSettingsOptions()
    
    useEffect(() => {
        if (!data) {
            refetch()
        }
    }, []);

    console.log(data)

    if(error) return <ApiError retryFetch={refetch} errorMessage={error.message}/>
    return (
        <CardWithLoader title={t("settings.userSettings.title")} isLoading={isLoading} lines={2} height={40}>
            <APIResultMessage success={success} error={saveError}/>
            <Row className="align-items-center">
                {data?.map((item, index) => ( TYPE_MAP[item.key] && 
                        <IconInput 
                            key={item.id}
                            label={t(`userSetting.${item.key}`)} 
                            iconKey={item.key} 
                            value={item.value} 
                            type={TYPE_MAP[item.key]} 
                            maxRange="100" 
                            rangeStep="10" 
                            onChange={(e) => {saveLineKey(item.id, "value", e.target.value)}}
                            options={TYPE_MAP[item.key] === 'elementSelect' && accountSettingsOptions || {}}
                        />
                ))}
            </Row> 
        </CardWithLoader>
);};

export default UserSettings;
